import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa';

export default function CardMobile(props) {
  var titulo = props.titulo;
  var destaque = props.destaque;
  var campos = props.campos || [];
  var colapsavel = props.colapsavel !== false;
  var iniciarAberto = props.iniciarAberto || false;

  var [aberto, setAberto] = useState(iniciarAberto);

  var podeExpandir = colapsavel && campos.length > 0;
  var mostrarCampos = campos.length > 0 && (!colapsavel || aberto);

  var toggleAberto = function() {
    if (podeExpandir) setAberto(function(v) { return !v; });
  };

  return (
    <Card
      className="mb-2"
      style={{
        border: '1px solid #f0f0f0',
        boxShadow: '0 1px 2px rgba(44,62,80,0.04)',
      }}
    >
      <Card.Body className="p-3">
        <div
          className="d-flex align-items-center"
          onClick={toggleAberto}
          style={{ cursor: podeExpandir ? 'pointer' : 'default' }}
        >
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                color: '#7b8ca6',
                fontSize: '0.7rem',
                lineHeight: 1.2,
              }}
            >
              {titulo}
            </div>
            <div
              style={{
                color: '#293c66',
                fontWeight: 600,
                fontSize: '0.95rem',
                lineHeight: 1.3,
                marginTop: 2,
              }}
            >
              {destaque}
            </div>
          </div>
          {podeExpandir && (
            <FaChevronDown
              size={14}
              style={{
                transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s',
                color: '#293c66',
                flexShrink: 0,
                marginLeft: 8,
              }}
            />
          )}
        </div>

        {mostrarCampos && (
          <>
            <hr className="my-2" />
            <Row>
              {campos.map(function(c, i) {
                return (
                  <Col xs={6} key={i} className="mb-2">
                    <div
                      style={{
                        color: '#7b8ca6',
                        fontSize: '0.7rem',
                        lineHeight: 1.2,
                      }}
                    >
                      {c.label}
                    </div>
                    <div
                      style={{
                        color: '#293c66',
                        fontWeight: 500,
                        fontSize: '0.85rem',
                        lineHeight: 1.3,
                      }}
                    >
                      {c.valor}
                    </div>
                  </Col>
                );
              })}
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
